import { render, staticRenderFns } from "./ConfiguracaoDeEstoque.vue?vue&type=template&id=06edb0f6"
import script from "./ConfiguracaoDeEstoque.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoDeEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports